import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  handleResponse(event) {
    const { detail } = event
    const { success, fetchResponse } = detail

    if (success && fetchResponse) {
      // Check for redirect URL in custom header
      const redirectUrl = fetchResponse.response.headers.get('X-Redirect-To')

      if (redirectUrl) {
        // Prevent Turbo from handling the response
        event.preventDefault()

        // Navigate to the redirect URL - browser will handle the deep link
        window.location.href = redirectUrl
      }
    }
  }
}
